import Vue from 'vue'
import VueRouter from 'vue-router'
import Page from '../views/Page.vue'
import NotFound from '../views/NotFound.vue'
import Report from '../views/Report.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:lang/reports/:slug',
    name: 'Report',
    component: Report
  },
  {
    path: '/',
    name: 'HomePage',
    component: Page
  },
  {
    path: '/:lang',
    name: 'HomePageLanguage',
    component: Page
  },
  {
    path: '/:lang/:slug',
    name: 'Page',
    component: Page
  },
  {
    name: 'NotFound',
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
